export const MOUSE_POINTER_ICON_SVG_SOURCE =
  '<svg viewBox="0 0 24 24" width="14" height="14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<path d="M5 2.5 L5 18.5 L9.2 14.3 L11.9 20.8 L14.3 19.8 L11.6 13.3 L17.5 13.3 Z" ' +
  'fill="currentColor" stroke="#0b0e11" stroke-width="1.2" stroke-linejoin="round"/>' +
  "</svg>";
